"use strict";

import Cookies from "./js-cookie/js.cookie.min.mjs"

window.cookies = Cookies;

const cookieEnum = {
    token: "logintoken"
};

function getCookie(cookie) {
    return cookies.get(cookie);
}

function setCookie(cookie, value, timeoutDays) {
    cookies.set(cookie, value, {
        expires: timeoutDays,
        // CSRF-Haertung: Cookie nicht bei cross-site-Requests senden. "Lax"
        // erlaubt weiterhin den Token-Link aus der E-Mail (Top-Level-GET).
        sameSite: "Lax",
        // Secure nur auf HTTPS setzen, damit lokale HTTP-Tests den Login-Cookie
        // weiterhin setzen koennen (Produktion + Testsubdomain laufen auf HTTPS).
        secure: (typeof location !== "undefined" && location.protocol === "https:")
    });
}

function removeCookie(cookie) {
    cookies.remove(cookie);
}

export {
    cookieEnum,
    getCookie,
    setCookie,
    removeCookie
}